import { ActionIcon, Checkbox, Popover, Stack } from '@mantine/core';

import { useCatalogLabels } from '../labels';

import type { ListColumn } from '../types';

interface ColumnPickerProps {
    /** Every column the user may switch on - the configured facets, see CatalogPage's
     * availableColumns (a facet is exactly an attribute worth showing as a column). */
    available: ListColumn[];
    /** Keys currently shown, in the caller's state (both callers share listColumnsAtom). */
    value: string[];
    onChange: (next: string[]) => void;
}

/**
 * The list view's "extra columns" picker. Shared by the catalog list and a system's own
 * Artikelliste (see chat: "Diese Möglichkeit möchte ich auch in der Darstellung System => Artikel
 * Liste") - one component so the two lists cannot drift apart on which attributes they offer or
 * how the control looks.
 *
 * Renders nothing when there is nothing to offer, rather than a button opening an empty dropdown.
 */
export const ColumnPicker = ({ available, value, onChange }: ColumnPickerProps) => {
    const { L } = useCatalogLabels();

    if (available.length === 0) {
        return null;
    }

    return (
        <Popover position="bottom-start" shadow="md" withArrow>
            <Popover.Target>
                <ActionIcon aria-label={L.columns} title={L.columns} variant="default">
                    <span className="material-symbols-outlined" style={{ fontSize: 20 }}>
                        view_column
                    </span>
                </ActionIcon>
            </Popover.Target>
            <Popover.Dropdown>
                <Checkbox.Group value={value} onChange={onChange}>
                    <Stack gap="xs">
                        {available.map((column) => (
                            <Checkbox key={column.key} label={column.label} value={column.key} />
                        ))}
                    </Stack>
                </Checkbox.Group>
            </Popover.Dropdown>
        </Popover>
    );
};
